import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { BotErrorView } from "./BotErrorView";
import { BotErrorViewStore } from "../../store/BotErrorViewStore";
import { useStore } from "../../../../hooks";

export const BotErrorViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/botError/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new BotErrorViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <BotErrorView botErrorViewStore={store} />
      </PageLayout>
    </div>
  );
});
